<ng-container *ngIf="interests && depreciations; else noData">
    <h3>
        {{'invest.eval.loaning.interest.shortLabel' | translate}}
        <app-tooltip [text]="'invest.eval.loaning.interest.summary' | translate"></app-tooltip>
    </h3>
    <app-loaning-datatable [data]="interests"></app-loaning-datatable>

    <h3>
        {{'invest.eval.loaning.depreciation.shortLabel' | translate}}
        <app-tooltip [text]="'invest.eval.loaning.depreciation.summary' | translate"></app-tooltip>
    </h3>
    <app-loaning-datatable [data]="depreciations"></app-loaning-datatable>
</ng-container>

<ng-template #noData>
    <p>{{'invest.eval.noData.summary' | translate}}</p>
</ng-template>
